import { createFileRoute } from "@tanstack/react-router";
import SeoAnalyzerPage from "@/pages/SeoAnalyzerPage";

export const Route = createFileRoute("/tools/seo-analyzer")({
  component: SeoAnalyzerPage,
});
